export const STRING = "STRING";
export const TEXT = "TEXT";
export const DATE = "DATE";
export const DATETIME = "DATETIME";
export const SELECT = "SELECT";
export const RADIOGROUP = "RADIOGROUP";
export const MULTICHECKBOX = "MULTICHECKBOX";
export const ENTRY = "ENTRY";



/** WEBPACK FOOTER **
 ** ./common/fieldTypes.js
 **/